import { render, staticRenderFns } from "./VibrometerThreshold.vue?vue&type=template&id=bfb2255a&scoped=true&"
import script from "./VibrometerThreshold.vue?vue&type=script&lang=js&"
export * from "./VibrometerThreshold.vue?vue&type=script&lang=js&"
import style0 from "./VibrometerThreshold.vue?vue&type=style&index=0&id=bfb2255a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2255a",
  null
  
)

/* custom blocks */
import block0 from "./VibrometerThreshold.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports